import Cookies from "js-cookie";
import { TokenStorage } from "../types";

export class CookieTokenStorage implements TokenStorage {
  private readonly ACCESS_TOKEN_KEY = "accessToken";
  private readonly REFRESH_TOKEN_KEY = "refreshToken";

  getAccessToken(): string | null {
    return Cookies.get(this.ACCESS_TOKEN_KEY) || null;
  }

  setAccessToken(token: string): void {
    Cookies.set(this.ACCESS_TOKEN_KEY, token, { path: "/", secure: true });
  }

  getRefreshToken(): string | null {
    return Cookies.get(this.REFRESH_TOKEN_KEY) || null;
  }

  setRefreshToken(token: string): void {
    Cookies.set(this.REFRESH_TOKEN_KEY, token, { path: "/", secure: true });
  }

  clearTokens(): void {
    Cookies.remove(this.ACCESS_TOKEN_KEY, { path: "/" });
    Cookies.remove(this.REFRESH_TOKEN_KEY, { path: "/" });
  }
}
